import moduleConfig from "./electronicsMarket.config";

export default [
    {
        path: moduleConfig.basePath,
        component: () => import("./electronicsMarket.module"),

        children: [
            {
                path: "electronics/:market",
                name: "electronicsMarket",
                component: () => import("./views/electronicsMarket.vue"),
            },
            {
                path: "electronicsListing/:data/:market",
                name: "electronics-listing",
                component: () => import("./views/electronicsListing.vue"),
            },
        ],
    },
];
